// extracted by mini-css-extract-plugin
export default {"button":"iUV0EN","qrCode":"ysI_mQ"};